module.exports = __webpack_public_path__ + "img/ico-info.5d61cc24.svg";